module.exports = __webpack_public_path__ + "img/ai-img-topbg.44ed991d.png";